import { useContext, useMemo, useState } from 'react';
// eslint-disable-next-line no-unused-vars
import Styled from 'styled-components/macro';

import { LoadingContext } from 'context/loadingContext';
import { AuthContext } from 'context/authContext';
import sideNavData from 'nav.json';
import { SideNavContext } from 'context/sideNavContext';
import { useMediaPredicate } from 'react-media-hook';
import { SidebarContainer, SideNavbar, NavHead, NavTitle, CloseButton, Nav, Ul } from './SideNav.styles';
import SubMenu from './SubMenu';

function Navbar() {
  const { toggleSideNav, sideNavState, setState } = useContext(SideNavContext);
  const [subnav, setSubnav] = useState({});
  const [filterSubMenu, setFilterSubMenu] = useState({});
  const showSubNav = id => {
    setSubnav(_ => ({ [id]: !_[id] }));
  };
  const showFilterSubMenu = id => {
    setFilterSubMenu(_ => ({ [id]: !_[id] }));
  };

  // eslint-disable-next-line no-unused-vars
  const { allowedPages } = useContext(AuthContext);
  const { isLoading } = useContext(LoadingContext);
  const sideBarItems = useMemo(
    () =>
      sideNavData
        .filter(({ file, navigations }) => navigations && allowedPages.includes(file))
        .filter(nav => nav.navigations)
        .map((item, index) => (
          <SubMenu
            showSubNav={showSubNav}
            subnav={subnav}
            showFilterSubMenu={showFilterSubMenu}
            filterSubMenu={filterSubMenu}
            item={item}
            key={index}
          />
        )),
    [isLoading, sideNavData, subnav, filterSubMenu],
  );
  const MaxWidth991 = useMediaPredicate('(max-width: 991px)');
  if (MaxWidth991) {
    setState(false);
  }
  return (
    <SidebarContainer>
      <SideNavbar
        css={isLoading && 'background:var(--dark);'}
        className={sideNavState && 'nav-active'}
        $loading={isLoading}>
        <Nav>
          <Ul>
            <li>
              <NavHead>
                <NavTitle> </NavTitle>
                <CloseButton onClick={toggleSideNav}>
                  <i className={`${sideNavState ? 'icon-menu' : 'icon-menu-expand'}`} />
                </CloseButton>
              </NavHead>
            </li>
            {sideBarItems}
          </Ul>
        </Nav>
      </SideNavbar>
    </SidebarContainer>
  );
}
export default Navbar;
